import { Component, Inject } from "@angular/core";
import { EVC_MODAL_REF, type ModalRef } from "../_shared/services/modal/evc-modal.service";

@Component({
  selector: "app-qrcode-support-page",
  templateUrl: "./qrcode-support-page.component.html",
  styleUrl: "./qrcode-support-page.component.scss",
  standalone: false
})
export class QRCodeSupportPageComponent {
  constructor(@Inject(EVC_MODAL_REF) private modalRef: ModalRef<any>) {}

  close() {
    this.modalRef.close();
  }
}
